import { message } from "antd";
import axiosInstance from "../config/axios-config";
import axiosInstanceV2 from "../config/axios-v2-config";
import {
  PatientMedicalInfoSchema,
} from "./Patients/MedicalProfile/PatientMedicalProfileForm";
import { FormValuesTypes } from "./Patients/Profile/PatientProfileForm";
import {
  convertErrorResponseToMessage,
  convertResponseToMessage,
} from "./utils";
import { AxiosError } from "axios";
import { z } from "zod";

type PatientDetails = {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  refferedBy?: string;
};

export type UpdateAppointmentInfo = {
  // patient: PatientBasicInfo?;
  type?: string;
  status?: string;
  consultingSlot?: string;
  startDateTime?: string;
  endDateTime?: string;
};
export async function searchPatient(
  firstName?: string | null,
  lastname?: string | null,
  phoneNumber?: string | null
) {
  try {
    const searchedPatients = await axiosInstanceV2.get(
      "/v2/patientinfo/searchpatients",
      {
        params: {
          firstName: firstName,
          lastName: lastname,
          phoneNumber: phoneNumber,
        },
      }
    );
    if (searchedPatients.status === 200) {
      return searchedPatients.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function addPatient(
  firstName: string | null,
  phoneNumber: string | null,
  lastName?: string | null,
  email?: string | null,
  refferedby?: string | null
) {
  try {
    const newPatient = await axiosInstanceV2.post("/v2/patientinfo", {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNumber,
      refferedBy: refferedby,
    });
    console.log(newPatient);
    return newPatient.data;
    // if (newPatient.status == 201) {
    //   return newPatient.data;
    // } else {
    //   return [];
    // }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function addAppointment(
  patientFirstName: string,
  patientLastName: string,
  patientPhoneNumber: string,
  appointmentStartDateTime: string,
  appointmentEndDateTime: string,
  // appointmentType: string,
  appointmentStatus: string,
  consultingSlot: string
) {
  try {
    const newAppointment = await axiosInstanceV2.post("/v2/appointments", {
      patientFirstName,
      patientLastName,
      patientPhoneNumber,
      appointmentStartDateTime: appointmentStartDateTime,
      appointmentEndDateTime: appointmentEndDateTime,
      // appointmentType: appointmentType,
      appointmentStatus: appointmentStatus,
      consultingSlot: consultingSlot,
    });
    return newAppointment.data;
    // if (newPatient.status == 201) {
    //   return newPatient.data;
    // } else {
    //   return [];
    // }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getAppointments() {
  try {
    const response = await axiosInstanceV2.get("/v2/appointments");
    // console.log(appointments);
    return convertResponseToMessage(
      response.status,
      "Retrieved latest Appointments",
      response.data
    );
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      return convertErrorResponseToMessage(error);
    } else {
      return convertErrorResponseToMessage(error);
    }
  }
}

export async function updateAppointment(
  appointmentUpdateInfo: UpdateAppointmentInfo,
  appointmentId: string
) {
  try {
    console.log(appointmentUpdateInfo);
    const updatedAppointmentResponse = await axiosInstanceV2.patch(
      "/v2/appointments",
      {
        id: appointmentId,
        type:
          appointmentUpdateInfo.type === undefined
            ? null
            : appointmentUpdateInfo.type,
        status:
          appointmentUpdateInfo.status === undefined
            ? null
            : appointmentUpdateInfo.status,
        consultingSlot:
          appointmentUpdateInfo.consultingSlot === undefined
            ? null
            : appointmentUpdateInfo.consultingSlot,
        startDateTime:
          appointmentUpdateInfo.startDateTime === undefined
            ? null
            : appointmentUpdateInfo.startDateTime,
        endDateTime:
          appointmentUpdateInfo.endDateTime === undefined
            ? null
            : appointmentUpdateInfo.endDateTime,
      }
    );

    return convertResponseToMessage(
      updatedAppointmentResponse.status,
      "Updated Appointemnt",
      updatedAppointmentResponse.data
    );
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      return convertErrorResponseToMessage(error);
    } else {
      return convertErrorResponseToMessage(error);
    }
  }
}
export async function getPatientBasicInfo(patientId: string) {
  try {
    const patientBasicInfo = await axiosInstanceV2.get("/v2/patientinfo", {
      params: {
        patientId: patientId,
      },
    });
    if (patientBasicInfo.status !== 200) {
      return null;
    }
    return patientBasicInfo.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function updatePatientBasicInfo(
  patientId: String,
  patientBasicInfo: FormValuesTypes
) {
  try {
    const updatedPatient = await axiosInstanceV2({
      method: "patch",
      url: "/v2/patientinfo",
      params: {
        patientId: patientId,
      },
      data: {
        firstName: patientBasicInfo.firstName,
        lastName: patientBasicInfo.lastName,
        email: patientBasicInfo.email,
        phoneNumber: patientBasicInfo.phoneNumber,
        refferedBy: patientBasicInfo.refferedBy,
      },
    });
    if (updatedPatient.status !== 200) {
      return null;
    }
    return updatedPatient.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getPatientMedicalInfo(patientId: string) {
  try {
    const patientMedicalInfo = await axiosInstanceV2.get("/v2/patient-medical", {
      params: {
        patientId: patientId,
      },
    });
    if (patientMedicalInfo.status !== 200) {
      console.log("Return null");
      return null;
    }

    return patientMedicalInfo.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 404) {
        return null;
      }
    }
    // throw error;
    return null;
  }
}
export async function updatePatientMedicalInfo(
  patientId: string,
  patientMedicalInfo: z.infer<typeof PatientMedicalInfoSchema>
) {
  try {
    var dateOfBirth;
    if (patientMedicalInfo.dateOfBirth !== undefined) {
      dateOfBirth = patientMedicalInfo.dateOfBirth.toISOString();
    }
    const updatedPatientMedicalInfo = await axiosInstanceV2({
      method: "put",
      url: "/v2/patient-medical",
      params: {
        patientId: patientId,
      },
      data: {
        diabetesMellitus: patientMedicalInfo.diabetesMellitus,
        hypertension: patientMedicalInfo.hypertension,
        ishaemicHeartDisease: patientMedicalInfo.ishaemicHeartDisease,
        respiratoryDisorders: patientMedicalInfo.respiratoryDisorders,
        allergies: patientMedicalInfo.allergies,
        previousSurgeries: patientMedicalInfo.previousSurgeries,
        bloodDyscrasias: patientMedicalInfo.bloodDyscrasias,
        hypothyroidism: patientMedicalInfo.hypothyroidism,
        pregnancyAndRelatedIssues: patientMedicalInfo.pregnancyAndRelatedIssues,
        psychiatricAilments: patientMedicalInfo.psychiatricAilments,
        dateOfBirth: dateOfBirth,
        gender: patientMedicalInfo.gender,
        bloodGroup: patientMedicalInfo.bloodGroup,
        other: patientMedicalInfo.other,
      },
    });

    if (updatedPatientMedicalInfo.status != 201) {
      return null;
    }

    return updatedPatientMedicalInfo.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getAvailableAppointmentSlots(
  consultingStartTime: string,
  consultingEndTime: string
) {
  try {
    var response = await axiosInstanceV2.get(
      "/v2/appointments/consulting-slots",
      {
        params: {
          consultingStartTime: consultingStartTime,
          consultingEndTime: consultingEndTime,
        },
      }
    );
    if (response.status !== 200) {
      return [];
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function deleteAppointment(appointmentId: string) {
  try {
    var response = await axiosInstanceV2.delete("/v2/appointments", {
      params: {
        appointmentId: appointmentId,
      },
    });
    if (response.status !== 200) {
      return false;
    } else {
      return true;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 * Fetch paginated brand drug data.
 * @param page The page number (1-based).
 * @param size The number of items per page.
 * @param token The Bearer token for authorization.
 * @returns The paginated brand drug data.
 */
export async function getPaginatedBrandDrugs(page: number, size: number) {
  try {
    // The legacy /v1/brand-drug/paginated was not actually paginated — it
    // returned the full category→generic→brand tree, which v2 already serves
    // with the identical shape on the category route.
    const response = await axiosInstanceV2.get(
      "/v2/categories/with-generics-and-brands"
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
